import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import profilePicThumbImg from "../assets/images/profile_av.png";
import { AiOutlineLogout } from "react-icons/ai";
import { Link } from "react-router-dom";
import { HiOutlineUserGroup } from "react-icons/hi";
import { GiNightSleep } from "react-icons/gi";
import { BsFillSunFill } from "react-icons/bs";

export default function MenuDropdown({
  user,
  handleLogout,
  toggleDarkMode,
  darkMode,
}) {
  return (
    <div className="mt-0.5">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button
            title="menu"
            className="w-[42px] h-[42px] rounded-full overflow-hidden border-[4px] border-white grayscale-[30%] hover:filter-none transition duration-200"
          >
            <img src={user?.image || profilePicThumbImg} alt="User profile" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 mt-2 min-w-[14rem] origin-top-right divide-y divide-gray-200 dark:divide-[#333] border border-gray-200 dark:border dark:border-[#333] rounded-md bg-gray-100 dark:bg-darkModeBg shadow-custom focus:outline-none">
            <div className="px-1 py-1">
              <div className="flex items-center gap-4 p-3">
                <div className="w-[38px] h-[38px]">
                  <img
                    className="w-full h-full grayscale-[50%] hover:filter-none transition duration-100 rounded-full overflow-hidden object-cover"
                    src={user?.image || profilePicThumbImg}
                    alt={user?.name || "Unknown user"}
                  />
                </div>
                <div className="text-sm flex flex-col">
                  <span className="text-base text-gray-700 dark:text-darkWhite capitalize">
                    {user?.name || "Unknown user"}
                  </span>
                  <span className="text-[#9399a1]">
                    {user?.email || "No email found"}
                  </span>
                </div>
              </div>
            </div>
            {/* Manage Users */}
            {user.role === "admin" && (
              <Menu.Item>
                {({ close }) => (
                  <Link
                    onClick={close}
                    to={"/manage-user"}
                    className="flex gap-2 items-center justify-start py-3.5 px-3 duration-200 transition-colors w-full text-sm text-gray-700 dark:text-darkWhite capitalize hover:bg-gray-200 dark:hover:bg-[#333] pl-6"
                  >
                    <button type="button" title="Manage Users">
                      <span>
                        <HiOutlineUserGroup className="inline text-2xl mr-6 text-gray-500 dark:text-gray-300" />
                      </span>
                      <span>Manage Users</span>
                    </button>
                  </Link>
                )}
              </Menu.Item>
            )}

            {/* light/dark toggle */}
            <button
              onClick={toggleDarkMode}
              title="Toggle light/dark mode"
              className="lg:hidden flex gap-2 items-center justify-start py-3.5 px-3 duration-200 transition-colors w-full text-sm text-gray-700 dark:text-darkWhite capitalize hover:bg-gray-200 dark:hover:bg-[#333] pl-6"
            >
              <span className="block mr-4">
                {!darkMode ? (
                  <BsFillSunFill className="inline text-2xl mr-0 text-gray-500 dark:text-gray-300" />
                ) : (
                  <GiNightSleep className="inline text-2xl mr-0 text-gray-500 dark:text-gray-300" />
                )}
              </span>
              <span> {darkMode ? "dark" : "light"} mode</span>
            </button>
            <div className="">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={handleLogout}
                    className={`${
                      active
                        ? "bg-secondary/80 text-white"
                        : "bg-secondary text-white"
                    } group flex w-full items-center rounded-b-md gap-1 uppercase tracking-wide px-2 py-3 text-sm justify-center`}
                  >
                    Sign out
                    <AiOutlineLogout className="text-base" />
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
